import { useTranslation } from "next-i18next";
import { useMemo } from "react";
import { sortListByAttribute } from "./sort-utils";

export type CargillRequestPortals = {
  name: string;
  appRefName: string;
}[];

/**
 * Gets portals list based on translations, sorted for forms.
 * @returns a list of portals, pairs of name and app name refs
 */
export function useCargillRequestedPortals() {
  const { t, i18n } = useTranslation();
  const data = useMemo(() => {
    const other = t("request_access:more_information.other");
    const list = t("request_access:more_information.requested_portal_list");
    const json = JSON.parse(list) as CargillRequestPortals;
    const sorted = sortListByAttribute("name", json, other);
    return sorted;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, t]);

  return data;
}
